export default __webpack_public_path__ + "static/media/boxRedIcon.d707dd56.png";